export default {
  Account: `Счет`,
  Pricing: `Цены`,
  FAQ: `Вопросы и ответы`,
  Contact: `Контакт`,
  "Log in": `Войти`,
  "UNITED BANKING": `ОБЪЕДИНЕННЫЙ <br>БАНКОВСКИЙ`,
  "Connect your partners into unified ecosystem for rapid and secure fund flows": `Соедините своих партнеров в единую экосистему <br />для быстрых и безопасных денежных потоков`,
  header: {
    "Sign Up": `Регистрация`,
  },
  account: {
    "PERSONAL AND BUSINESS ACCOUNT": `ЛИЧНЫЙ<br />И БИЗНЕС<br> СЧЕТ`,
    "Manage all your financial transactions": `Управляйте всеми вашими финансовыми транзакциями,<br> делайте и получайте платежи.<br> Все в одном месте.`,
    "Create Account": `Создать счет`,
    "Fast online application and onboarding": `Быстрая онлайн заявка и регистрация`,
    "Execute all banking tasks at lightspeed": `Выполняйте все банковские задачи со скоростью света`,
    "SEPA & SWIFT for easy fund transfers globally": `SEPA и SWIFT для легких денежных переводов по всему миру`,
    "Crypto payments and investments": `Крипто платежи и инвестиции`,
    "Personalized support available anytime": `Персонализированная поддержка в любое время`,
    "TOP-TIER SECURITY": `ВЫСОКИЙ УРОВЕНЬ БЕЗОПАСНОСТИ`,
    Trust: `Доверяйте нашим передовым протоколам безопасности, разработанным для вашего спокойствия, чтобы вы могли сосредоточиться на управлении своими финансами с уверенностью.`,
    "SMOOTH TRANSACTIONS": `ПЛАВНЫЕ <br>ТРАНЗАКЦИИ`,
    "INTEGRATED ECOSYSTEM": `ИНТЕГРИРОВАННАЯ ЭКОСИСТЕМА`,
    "Our platform": `Наша платформа соединяет всех ваших партнеров, сотрудников и подрядчиков в одном едином центре. Наслаждайтесь бесшовным сотрудничеством и упрощенной коммуникацией по всей вашей сети.`,
    Experience: `Испытайте бесшовные и эффективные транзакции, как никогда раньше. Наша платформа обеспечивает быструю, безопасную и беспроблемную обработку всех платежей и банковских операций.`,
  },
  features: {
    "UNITY AT THE CORE": `ЕДИНСТВО <br>В ЦЕНТРЕ`,
  },
  EXPLORE: `Исследовать`,
  "EXPLORE A COMPLETE FINANCIAL PLATFORM POWERED BY BANK ACCOUNT": `ИССЛЕДУЙТЕ ПОЛНУЮ ФИНАНСОВУЮ ПЛАТФОРМУ, ПОДКРЕПЛЕННУЮ БАНКОВСКИМ СЧЕТОМ`,
  pricing: {
    PRICING: `Цены`,
    "EXPLORE OUR PRICING": `ИССЛЕДУЙТЕ НАШИ ЦЕНЫ`,
    BUSINESS: `БИЗНЕС`,
    PERSONAL: `ЛИЧНЫЙ`,
    "PRIVATE INDIVIDUALS": `ЧАСТНЫЕ ЛИЦА`,
    "Contact Sales": `Связаться с отделом продаж`,
    "Handling of documents and opening a customer account": `Обработка документов и открытие клиентского счета`,
    "Account monthly service fee": `Ежемесячная плата за обслуживание счета`,
    "Incoming internal payment": `Входящий внутренний платеж`,
    "Incoming SEPA-paymen": `Входящий SEPA-платеж`,
    "Incoming SWIFT-payment": `Входящий SWIFT-платеж`,
    "Internal outgoing payment between own accounts with in Swipez": `Исходящий внутренний платеж между собственными счетами внутри Swipez`,
    "Internal outgoing payment with in Swipez": `Исходящий внутренний платеж внутри Swipez`,
    "Internal outgoing payment": `Исходящий внутренний платеж`,
    "Outgoing SEPA-payment": `Исходящий SEPA-платеж`,
    "Outgoing SWIFT-paymen": `Исходящий SWIFT-платеж`,
    "Withdrawal to card": `Вывод на карту`,
    "Payment card top-up": `Пополнение платежной карты`,
    "Free of change": `Бесплатно`,
  },
  faq: {
    FAQ: `ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ`,
  },
  questtions: {
    "FREQUENTLY ASKED QUESTIONS": `ЧАСТО<br>ЗАДАВАЕМЫЕ ВОПРОСЫ`,
    "Swipez company is registered in the Czech Republic": `Компания Swipez зарегистрирована в Чешской Республике.`,
    "What country is Swipez registered at?": `В какой стране зарегистрирован Swipez?`,
    "When opening an account, a passport or ID card is required": `При открытии счета необходим паспорт или удостоверение личности, а также счет за коммунальные услуги или выписка по счету с указанием вашего имени и адреса.`,
    "How safe is Swipez service?": `Насколько безопасен сервис Swipez?`,
    "What documents must be presented for opening an account?": `Какие документы нужно предоставить для открытия счета?`,
    "When will I get access to the online bank?": `Когда я получу доступ к онлайн-банку?`,
    "Residents of what countries may not open an account?": `Жители каких стран не могут открыть счет?`,
  },
  footer: {
    "NEED OUR TEAM HELP?": `НУЖНА ПОМОЩЬ<br> НАШЕЙ КОМАНДЫ?`,
    "Privacy Policy": `Политика конфиденциальности`,
    "Terms and Conditions": `Условия и положения`,
    "Claims Procedure": `Процедура подачи претензий`,
    "Cryptocurrency Exchange Notice": `Уведомление о криптовалютных обменах`,
    desk0: `Чтобы узнать, какая компания Revolut обслуживает вас, или если у вас есть какие-либо вопросы, пожалуйста, свяжитесь с нами через наш чат в приложении.`,
    desk1: `Revolut Ltd зарегистрирована в Англии и Уэльсе (№ 08804411), 7 Westferry Circus, Canary Wharf, Лондон, Англия, E14 4HD и авторизована Управлением финансового надзора в соответствии с Регламентом о денежных средствах 2011 года (номер фирмы 900562). Revolut Travel Ltd имеет разрешение Управления финансового надзора на осуществление страховой деятельности (номер FCA: 780586). Наши страховые продукты предоставляются Revolut Travel Ltd и Revolut Ltd, которая является назначенным представителем Revolut Travel Ltd. Продукты Revolut для торговли акциями предоставляются Revolut Trading Ltd (№ 832790), назначенным представителем Resolution Compliance Ltd, которая имеет разрешение и регулируется Управлением финансового надзора.`,
    desk2: `Revolut Ltd также зарегистрирована в Управлении финансового надзора для предоставления услуг с криптовалютами в соответствии с Регламентом о борьбе с отмыванием денег, финансированием терроризма и переводом средств (информация о плательщике) 2017 года. Услуги по драгоценным металлам предоставляются Revolut Ltd и не регулируются Управлением финансового надзора.`,
    "Complaints Disclaimer": `Отказ от претензий`,
    "Safeguarding Disclaimer": `Отказ от ответственности`,
    "All rights reserved": `Все права защищены. Все другие товарные знаки, названия продуктов и логотипы, указанные или упомянутые здесь, являются собственностью соответствующих владельцев. Используя этот веб-сайт и/или наши услуги, вы соглашаетесь внимательно прочитать, принять и стать юридически связанными Условиями использования, Политикой подачи жалоб и Политикой конфиденциальности. Оператором этого веб-сайта является Draph Solutions s.r.o. со штаб-квартирой по адресу Národní 961/25, Staré Město, 110 00 Praha 1, Czech Republic, чешское финансовое учреждение, лицензированное и регулируемое Чешским национальным банком, имеющее юридические полномочия для открытия личных и деловых текущих счетов, а также для обеспечения внутренних и международных платежей. Лицензия, выданная Чешским национальным банком в соответствии с Законом № 370/2017 Сб. Закон о платежных услугах.`,
  },
  Call: `Телефон`,
  Email: `эл.почта`,
  "Back to website": `Вернуться на сайт`,
  privacyPolicy: {
    Privacy: `Политика`,
    Policy: `конфиденциальности`,
  },
  terms: {
    And: `<li>`,
  },
  complaints: {
    disclaimer: `<ol>`,
  },
  safeguarding: {
    safeguarding: `<li>O DRAPH</li>`,
  },
};
